import styled from "styled-components";

export const InfoBubbleTooltipContentBox = styled.div` 
    max-width: 164px;
`;